import util from '@bmp-vue/core/api/util';

const controller = 'SysUsuario';
export default Object.assign({}, util.GetCrud(controller, null), {
  GetBMPUsersByUserId (dto) {
    return util.Axios.GetParams(controller + '/GetBMPUsersByUserId', dto);
  }
});
